'use strict';

angular.module('authController', [])
.controller('AuthController', ['$scope','$log','$window', '$rootScope','$location','AuthenticationService',
    function ($scope, $log, $window, $rootScope, $location, AuthenticationService) {

        var appInfo = $rootScope.appInfo;

        //reset login status
        AuthenticationService.ClearCredentials();

        $rootScope.auth = false;

        //Login function
        $scope.login = function () {
             $rootScope.loading = true;
             $rootScope.firstOpen = true;

             AuthenticationService.Login('seller', $scope.username, $scope.password, function (response) {
                if (response.access) {
                    AuthenticationService.SetAccess(response);
                    $location.path('/home');
                } else {
                    $scope.error = response.message;
                    $rootScope.loading = false;
                    alert('Please contact your Agent');
                }
            });
        };

        $scope.loadWebsite = function(){
            window.location.href = 'http://www.wiseberry.com.au';
        }


        //Logout function
        $scope.logout = function () {
            var accessKey = $rootScope.currentUser.authdata;
            AuthenticationService.LogOut(key, accessKey, function(data) {
               AuthenticationService.ClearCredentials();
               $location.path('/logout');
            })
        };

        $window.scrollTo(0, angular.element('.login').offsetTop);  

}]);